import { graphql } from '../../generated';

export const GET_EVENT_STATISTICS = graphql(`
  query EventStatisticsQuery($id: ID!) {
    product(id: $id) {
      id
      ... on Event {
        pricingCategoryStatistics {
          productVariantDescription
          brutPrice
          price
          count
          physical
          pricingCategoryName
          total
        }
      }
    }
  }
`);
